<template>
  <div class="threads_list">
    <section class="text_center no_padding">
      <h2 class="header_underline">{{ noMailWord }}メール鑑定師別BOX一覧</h2>
      <div v-if="filteredActors != null">
        <ul class="mail_list_box pl-0">
          <li v-for="(entry, index) in filteredActors" :key="index">
            <router-link :to="goRoute(entry)" class="menu_list_font--text">
              <span class="mail_list_box_title">
                <v-icon class="mr-1">mdi-account-circle</v-icon>
                <span>{{ entry.name }}鑑定師BOX</span>
              </span>
              <span v-if="type === 'new'" class="mail_list_box_subtitle">{{ entry.name }}鑑定師からの新着メールが<span class="unread_count">{{ entry.unread_count }}</span>件あります！</span>
              <span v-else class="mail_list_box_subtitle">{{ entry.name }}{{ listText }}</span>
            </router-link>
          </li>
        </ul>
        <p v-if="filteredActors.length == 0"  class="text_center mail_box_empty">
          {{ noMailWord }}メールはありません。
        </p>
      </div>
    </section>
    <section class="text_center">
      <ul v-if="filteredActors != null" class="pagination pl-0">
        <li
          v-if="isPrev"
          class="prev link_main--text text-decoration-underline"
        ><span @click="goPagination('prev')">前へ</span></li>
        <li
          v-if="isNext"
          class="next link_main--text text-decoration-underline"
        ><span @click="goPagination('next')">次へ</span></li>
      </ul>
      <p>
        <router-link :to="{ name: 'MailList' }" class="arrow link_main--text">メールBOX一覧に戻る</router-link>
      </p>
    </section>
  </div>
</template>
<script>
import Vue from 'vue'
import { GET_THREADS } from '@/store/message/actions'

export default {
  name: 'MailThreads',
  props: {
    type: String
  },
  data () {
    return {
      page: this.$route.query.page || 0,
      currentPage: (this.$store.getters.threads != null) ? this.$store.getters.threads.current_page : 0,
      total: (this.$store.getters.threads != null) ? this.$store.getters.threads.total : 0,
      perPage: (this.$store.getters.threads != null) ? this.$store.getters.threads.per_page : 0,
      actors: (this.$store.getters.threads != null) ? this.$store.getters.threads.actors : null,
      loading: true
    }
  },
  computed: {
    filteredActors () {
      if (this.type === 'new') {
        if (Array.isArray(this.actors)) {
          return this.actors.filter(entry => entry.unread_count > 0)
        }
      }
      return this.actors
    },
    listText () {
      let listTextStr = ''
      switch (this.type) {
        case 'received':
          listTextStr = '鑑定師に送信したメールはこちら'
          break
        case 'read':
          listTextStr = '鑑定師からの一度読んだメールはこちら'
          break
      }
      return listTextStr
    },
    noMailWord () {
      let str = ''
      switch (this.type) {
        case 'new':
          str = '新着'
          break
        case 'received':
          str = '送信'
          break
        case 'read':
          str = '既読'
          break
      }
      return str
    },
    isPrev () {
      return (this.currentPage > 1)
    },
    isNext () {
      return (this.currentPage < this.pageCount)
    },
    pageCount () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    getThreads () {
      this.$store.dispatch(GET_THREADS, {
        params: {
          params: {
            type: this.type,
            page: this.page
          }
        }
      })
        .then((data) => {
          this.currentPage = data.current_page
          this.total = data.total
          this.perPage = data.per_page
          this.actors = data.actors
        })
        .catch(() => {
          this.$router.go(-1)
        })
    },
    goRoute (entry) {
      const nameMap = {
        new: 'MailBoxNew',
        received: 'MailBoxReceived',
        read: 'MailBoxRead'
      }
      return {
        name: nameMap[this.type],
        params: { actor_id: entry.id }
      }
    },
    goPagination (type) {
      const nextPage = (type === 'prev') ? this.currentPage - 1 : this.currentPage + 1
      const params = Vue.util.extend({}, this.$route.params)
      const query = Vue.util.extend({}, this.$route.query)
      query.page = String(nextPage)
      this.page = nextPage
      this.$router.pushIsses({ name: this.component, params: params, query: query })
    }
  },
  created () {
    this.getThreads()
  },
  watch: {
    page: function () {
      this.currentPage = this.total = this.perPage = 0
      this.actors = null
      this.getThreads()
    }
  }
}
</script>
